import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { LOCALE } from '../../../../../i18n'
import { StaticImage } from '../../../../../image'
import { RxLpChVoucherCircle } from '../VoucherCircle/VoucherCircle'

import rezept from './heroImages/rezept.png'
import rezeptFrench from './heroImages/rezeptFrench.png'
import womanLooking from './heroImages/womanLooking.png'
import womanLookingMobile from './heroImages/womanLookingMobile.png'
import { RxLpChHeroDescription } from './RxLpChHeroDescription'

export const RxLpChHero: FC = () => {
  const intl = useIntl()
  const prescriptionImage = intl.locale === LOCALE.DE_CH ? rezept : rezeptFrench

  return (
    <>
      {/* desktop layout */}
      <div className="mx-auto hidden bg-light-brand-low tablet:flex tablet:justify-center tablet:gap-28">
        <div className="relative flex items-center justify-center">
          <StaticImage alt="" height={546} src={womanLooking} width={746} />
          <StaticImage
            alt=""
            className="absolute -right-40 top-64"
            height={400}
            src={prescriptionImage}
            width={550}
          />
          <div className="absolute -right-16 top-28">
            <RxLpChVoucherCircle />
          </div>
        </div>
        <div className="relative mx-auto inline-flex flex-col items-center justify-start tablet:gap-4 tablet:py-5 tablet:pr-40">
          <RxLpChHeroDescription />
        </div>
      </div>
      {/* mobile layout */}
      <div className="flex w-full flex-col bg-light-primary-medium tablet:hidden">
        <div className="relative shrink-0">
          <StaticImage
            alt=""
            className="mr-10"
            height={250}
            src={womanLookingMobile}
          />
          <div className="relative overflow-x-clip">
            <StaticImage
              alt=""
              className="absolute -right-4 -top-52 -rotate-12"
              height={240}
              src={prescriptionImage}
              width={310}
            />
          </div>
          <div className="absolute right-4 top-7">
            <RxLpChVoucherCircle />
          </div>
        </div>
        <div className="px-4 py-6">
          <RxLpChHeroDescription />
        </div>
      </div>
    </>
  )
}
